export const formRetired = {
  draftNotAvailableAriaLabel: {
    en: 'Draft not available.',
    nb: 'Utkast ikke tilgjengelig.',
    nn: 'Utkast ikkje tilgjengeleg.',
  },
  draftNotAvailableText: {
    en: 'The draft for this application is no longer available, and you must create a new application to submit.',
    nb: 'Utkastet for denne søknaden er ikke lenger tilgjengelig, og du må opprette en ny søknad for å sende inn.',
    nn: 'Utkastet for denne søknaden er ikkje lenger tilgjengeleg, og du må opprette ein ny søknad for å sende inn.',
  },
  applicationConferenceAttendanceLink: {
    en: 'https://prosjekt.innovasjonnorge.no',
    nb: 'https://prosjekt.innovasjonnorge.no',
    nn: 'https://prosjekt.innovasjonnorge.no',
  },
  applicationConferenceAttendanceLinkText: {
    en: 'Create new application for export promotion',
    nb: 'Opprett ny søknad for eksportfremstøt',
    nn: 'Opprett ny søknad for eksportframstøyt',
  },
  applicationConferenceOrganiseAbroadLink: {
    en: 'https://prosjekt.innovasjonnorge.no',
    nb: 'https://prosjekt.innovasjonnorge.no',
    nn: 'https://prosjekt.innovasjonnorge.no',
  },
  applicationConferenceOrganiseAbroadLinkText: {
    en: 'Create new application for pre-approval of trade fair for export promotion',
    nb: 'Opprett ny søknad for forhåndsgodkjenning av messe for eksportfremstøt',
    nn: 'Opprett ny søknad for førehandsgodkjenning av messe for eksportframstøyt',
  },
};
